import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { ExploreBlockType } from '@addmile/backend-client';

export type ContentViewMode =
  | 'list'
  | 'editor'
  | 'createCollection'
  | 'editCollection'
  | 'collectionBlocks';

interface ContentViewState {
  viewMode: ContentViewMode;
  editingSlug?: string;
  draftType?: ExploreBlockType;
  editCollectionSlug?: string;
  collectionBlocksSlug?: string;
  showCopyBlockModal: boolean;
  copyBlockSlug?: string;

  setShowCopyBlockModal: (show: boolean) => void;
  setViewMode: (mode: ContentViewMode) => void;
  setEditingSlug: (slug?: string) => void;
  setDraftType: (type?: ExploreBlockType) => void;
  setEditCollectionSlug: (slug?: string) => void;
  setCollectionBlocksSlug: (slug?: string) => void;
  resetView: () => void;
}

export const useContentViewStore = create<ContentViewState>()(
  persist(
    immer((set) => ({
      viewMode: 'list' as ContentViewMode,
      editingSlug: undefined,
      draftType: undefined,
      editCollectionSlug: undefined,
      collectionBlocksSlug: undefined,
      showCopyBlockModal: false,
      copyBlockSlug: undefined,

      setShowCopyBlockModal: (show) => set((state) => void (state.showCopyBlockModal = show)),
      setViewMode: (mode) => set((state) => void (state.viewMode = mode)),
      setEditingSlug: (slug) => set((state) => void (state.editingSlug = slug)),
      setDraftType: (type) => set((state) => void (state.draftType = type)),
      setEditCollectionSlug: (slug) => set((state) => void (state.editCollectionSlug = slug)),
      setCollectionBlocksSlug: (slug) => set((state) => void (state.collectionBlocksSlug = slug)),
      resetView: () =>
        set((state) => {
          state.viewMode = 'list';
          state.editingSlug = undefined;
          state.draftType = undefined;
          state.editCollectionSlug = undefined;
          state.collectionBlocksSlug = undefined;
        }),
    })),
    {
      name: 'content-view-storage',
    },
  ),
);
